<div class="manage-subscription">
  <button
    type="button"
    class="manage-subscription__trigger"
    [class.manage-subscription__trigger--open]="open"
    [attr.aria-expanded]="open"
    aria-haspopup="menu"
    (click)="toggle()"
  >
    {{ label }}
    <!-- Points up because the menu opens upward, open or closed. -->
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path
        d="M4 10L8 6L12 10"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>

  @if (open) {
    <div class="manage-subscription__menu" role="menu">
      @if (showEditDetails) {
        <button
          type="button"
          class="manage-subscription__item"
          role="menuitem"
          data-testid="manage-edit-details"
          (click)="choose(editDetails)"
        >
          <span class="manage-subscription__icon" aria-hidden="true">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path
                d="M12.75 2.25L15.75 5.25L6 15H3V12L12.75 2.25Z"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span class="manage-subscription__copy">
            <span class="manage-subscription__title">Edit Details</span>
          </span>
        </button>
      }

      @if (showUpdate) {
        <button
          type="button"
          class="manage-subscription__item"
          role="menuitem"
          data-testid="manage-update"
          title="Change plans or subscription details"
          (click)="choose(update)"
        >
          <span class="manage-subscription__icon" aria-hidden="true">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path
                d="M12.75 2.25L15.75 5.25L6 15H3V12L12.75 2.25Z"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span class="manage-subscription__copy">
            <span class="manage-subscription__title">Update</span>
            <span class="manage-subscription__desc">Change plans or subscription details</span>
          </span>
        </button>
      }

      @if (showCancelScheduled) {
        <button
          type="button"
          class="manage-subscription__item"
          role="menuitem"
          data-testid="manage-cancel-scheduled"
          (click)="choose(cancelScheduledPause)"
        >
          <span
            class="manage-subscription__icon manage-subscription__icon--pause"
            aria-hidden="true"
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <rect x="4" y="3" width="3.5" height="12" rx="1" fill="currentColor" />
              <rect x="10.5" y="3" width="3.5" height="12" rx="1" fill="currentColor" />
            </svg>
          </span>
          <span class="manage-subscription__copy">
            <span class="manage-subscription__title">Cancel scheduled pause</span>
            <span class="manage-subscription__desc">Keep this membership active</span>
          </span>
        </button>
      } @else if (showPause) {
        <button
          type="button"
          class="manage-subscription__item"
          role="menuitem"
          data-testid="manage-pause"
          title="Pause this membership for 1-4 months"
          (click)="choose(pause)"
        >
          <span
            class="manage-subscription__icon manage-subscription__icon--pause"
            aria-hidden="true"
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <rect x="4" y="3" width="3.5" height="12" rx="1" fill="currentColor" />
              <rect x="10.5" y="3" width="3.5" height="12" rx="1" fill="currentColor" />
            </svg>
          </span>
          <span class="manage-subscription__copy">
            <span class="manage-subscription__title">Pause</span>
            <span class="manage-subscription__desc">1-4 months, $0 on resume</span>
          </span>
        </button>
      }

      @if (showPaymentMethod) {
        <button
          type="button"
          class="manage-subscription__item"
          role="menuitem"
          data-testid="manage-payment-method"
          title="Update your payment details"
          (click)="choose(paymentMethod)"
        >
          <span class="manage-subscription__icon" aria-hidden="true">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <rect
                x="1.75"
                y="3.75"
                width="14.5"
                height="10.5"
                rx="2"
                stroke="currentColor"
                stroke-width="1.5"
              />
              <path d="M1.75 7.25H16.25" stroke="currentColor" stroke-width="1.5" />
              <path d="M4.5 11H7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            </svg>
          </span>
          <span class="manage-subscription__copy">
            <span class="manage-subscription__title">Update Payment method</span>
            <span class="manage-subscription__desc">Update your payment details</span>
          </span>
        </button>
      }

      <!-- CWS-1581: opens the Start Family pop-up; nothing changes until it is confirmed there. -->
      @if (showStartFamily) {
        <button
          type="button"
          class="manage-subscription__item"
          role="menuitem"
          data-testid="manage-start-family"
          title="Make this membership the primary of a Family Plan"
          (click)="choose(startFamily)"
        >
          <span class="manage-subscription__icon" aria-hidden="true">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <circle cx="6.5" cy="6" r="2.5" stroke="currentColor" stroke-width="1.5" />
              <path
                d="M2 14.5C2 12.3 3.9 10.5 6.5 10.5C9.1 10.5 11 12.3 11 14.5"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M13 5.5V10M10.75 7.75H15.25"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </span>
          <span class="manage-subscription__copy">
            <span class="manage-subscription__title">Start Family</span>
            <span class="manage-subscription__desc">Add vehicles at a family discount</span>
          </span>
        </button>
      }

      <!-- CWS-1780: opens the cancel & refund panel; nothing is cancelled until it is confirmed there. -->
      @if (showCancel) {
        <button
          type="button"
          class="manage-subscription__item"
          role="menuitem"
          data-testid="manage-cancel"
          title="Stop the membership, with a refund if one is due"
          (click)="choose(cancelMembership)"
        >
          <span
            class="manage-subscription__icon manage-subscription__icon--cancel"
            aria-hidden="true"
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <circle cx="9" cy="9" r="6.75" stroke="currentColor" stroke-width="1.5" />
              <path
                d="M6.5 6.5L11.5 11.5M11.5 6.5L6.5 11.5"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </span>
          <span class="manage-subscription__copy">
            <span class="manage-subscription__title">Cancel membership</span>
            <span class="manage-subscription__desc">Stop renewal, refund if due</span>
          </span>
        </button>
      }

      @if (showMoveToOwnNumber) {
        <button
          type="button"
          class="manage-subscription__item"
          role="menuitem"
          data-testid="manage-move-to-own-number"
          (click)="choose(moveToOwnNumber)"
        >
          <span class="manage-subscription__icon" aria-hidden="true">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path
                d="M3 9H14.5M14.5 9L10.5 5M14.5 9L10.5 13"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span class="manage-subscription__copy">
            <span class="manage-subscription__title">Move to own number</span>
            <span class="manage-subscription__desc">Give this plate its own contact</span>
          </span>
        </button>
      }

      @if (showRemoveMember) {
        <button
          type="button"
          class="manage-subscription__item"
          role="menuitem"
          data-testid="manage-remove-member"
          (click)="choose(removeMember)"
        >
          <span
            class="manage-subscription__icon manage-subscription__icon--cancel"
            aria-hidden="true"
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <circle cx="7" cy="6" r="2.5" stroke="currentColor" stroke-width="1.5" />
              <path
                d="M2 14.5C2 12.3 3.9 10.5 7 10.5C8.2 10.5 9.2 10.8 10 11.3"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M11.5 7.5H16"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </span>
          <span class="manage-subscription__copy">
            <span class="manage-subscription__title">Remove member</span>
          </span>
        </button>
      }
    </div>
  }
</div>
